import { BellRing, Rocket, BugOff, Wrench } from "lucide-react";
import ScrollArea from 'react-scrollbar'

import { useChangelog } from "../../store/global/useChangelog";

export function Notifications() {
  const changelogs = useChangelog(st => st.data.logs)

  return (
    <div className="w-full rounded-lg border-zinc-200/30 shadow-md border p-4 gap-4 flex flex-col sm:col-span-2 sm:row-span-7 md:col-span-2 md:row-span-4 lg:col-span-3 lg:row-span-4 xl:col-span-2 xl:row-2 xl:row-span-7 bg-white">
      <div className="w-full flex">
        <span className="flex gap-2 text-scale-500 font-semibold text-lg items-center">
          <BellRing /> Notificações
        </span>
      </div>

      <ScrollArea smoothScrolling horizontal={false} className="w-full h-full">
        <div className="w-full flex flex-col gap-1 pb-1 pr-2.5">
          {changelogs.map((log) => (
            <a
              key={log.id}
              className="w-full group rounded-lg border-zinc-200/30 shadow-md border p-2 gap-4 flex items-center justify-center transition scale-95 duration-500 hover:scale-100 hover:duration-200 hover:bg-zinc-100 hover:border-zinc-400/30"
              title={`${log.title}\n${log.description}`}
              href={log.url}
              target="_blank"
              rel="noreferrer"
            >
              <div
                style={{ backgroundColor: log.color }}
                className="w-10 h-10 rounded-md flex items-center justify-center p-2  border-zinc-200/30 shadow-md border"
              >
                {log.code === 'new' && <Rocket className="w-full h-full text-white" />}
                {log.code === 'correction' && <BugOff className="w-full h-full text-white" />}
                {log.code === 'improvement' && <Wrench className="w-full h-full text-white" />}

              </div>
              <div className="flex flex-col w-[calc(100%_-_3.75rem)]">
                <p className="text-sm font-semibold w-full truncate text-zinc-600 transition-colors duration-500 group-hover:duration-200 group-hover:text-zinc-900">{log.title}</p>
                <p className="text-xs font-light w-full truncate  text-zinc-400 transition-colors duration-500 group-hover:duration-200 group-hover:text-zinc-500">{log.description}</p>
              </div>
            </a>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
}
